var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"clear":"both"}}),_c('el-collapse',{attrs:{"accordion":""}},_vm._l((_vm.helpList),function(im){return _c('el-collapse-item',{key:im.id,attrs:{"title":im.title,"name":im.id}},[_c('p',{domProps:{"innerHTML":_vm._s(im.content)}})])}),1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }